import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["frame", "forumBody", "minimizeIcon"]


  connect() {

  }

  minimize() {
    this.forumBodyTarget.classList.toggle("hidden")
    this.element.classList.toggle("h-16")
    this.minimizeIconTarget.classList.toggle("transform")
    this.minimizeIconTarget.classList.toggle("rotate-180")
  }

  close() {
    console.log("close")
    this.frameTarget.innerHTML = ""
    this.frameTarget.src = ""
  }

}